import { defineComponent as _defineComponent } from 'vue';
import StatelessTags from "@/components/TagsMultiselect/StatelessTags.vue";
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FormTags',
    props: {
        value: null,
        placeholder: null
    },
    emits: ["input"],
    setup(__props, { emit }) {
        const props = __props;
        const valueArray = computed(() => { var _a, _b; return (_b = (_a = props.value) === null || _a === void 0 ? void 0 : _a.split(",").map((v) => v.trim())) !== null && _b !== void 0 ? _b : []; });
        function onInput(tags) {
            emit("input", tags.join(","));
        }
        return { __sfc: true, props, emit, valueArray, onInput, StatelessTags };
    }
});
